import moment from 'moment';
import React, { useEffect, useRef } from 'react'
import ReactDatePicker from 'react-datepicker';
import calendarIcon from '../../assets/images/CommonComponent/calendarIcon.png';
import { validateDate } from '../../utils/Helper';
import './DatePicker.scss'
import {ReactComponent as CrossIcon} from '../../assets/images/CommonComponent/CrossIcon.svg'
import historyIcon from '../../assets/images/CommonComponent/history.svg'

function DatePicker({
  value, 
  showMonthDropdown=true, 
  showYearDropdown=true, 
  showTime, 
  onChange, 
  width, 
  popperPlacement, 
  maxDate, 
  minDate, 
  height, 
  className, 
  disabled=false, 
  isClearable, 
  placeholder, 
  showTimeSelect, 
  showTimeSelectOnly,
  timeFormat,
  timeIntervals,
  timeCaption

}) {
    const currentDateRef = useRef(null)
    const boxRef = useRef(null)

  useEffect(() => {
    function handleClick (){
      currentDateRef.current?.setOpen(true);
    }
    if (boxRef?.current) {
      boxRef.current.addEventListener('click', handleClick);
    }

    return () => {
      if (boxRef?.current) {
        boxRef.current?.removeEventListener('click', handleClick);
      }
    };
  }, []);

  return (
    <div className={`custom-date-picker ${className} ${disabled ? 'disabled' : ''}`} ref={boxRef}  style={{width: width|| '100%', height: height || '30px'}}>
        {!value ?
            <div className="dayDateTextDiv" ><p className="dayDateTextPlaceholder">{placeholder  || 'Select Date'}</p></div>
            : 
            <div className="dayDateTextDiv" >
                <p className="dayDateText d-flex ">
                    {showTimeSelectOnly ? (moment(value, "YYYY-MM-DD hh:mm A").format('HH:mm:ss')) : showTime ? (moment(value, "YYYY-MM-DD hh:mm A").format('DD/MM/YYYY HH:mm:ss')) : (moment(value, "YYYY-MM-DD hh:mm A").format('DD/MM/YYYY'))} 
                </p>
            </div>
        }
        {isClearable && <CrossIcon color='red' strokeWidth={1} onClick={()=>{onChange(''); currentDateRef.current?.setOpen(false);}} className='cross' />}
        <div>
          <ReactDatePicker
              showTimeSelect={showTimeSelect}
              onChange={date => { onChange(date) }}
              popperPlacement={popperPlacement || 'bottom'}
              {...(maxDate && {maxDate: maxDate})}
              {...(minDate && {minDate: minDate})}
              customInput={
                showTimeSelectOnly ?
                  <img src={historyIcon} className="remIcon" alt="" width="18" height="18" />
                  :
                  <img src={calendarIcon} className="calIcon" alt="" />
              }
              showTimeInput={showTime}
              timeInputLabel={'Time: '}       
              selected={value ? new Date(value): (minDate ||new Date())}    
              showMonthDropdown={showMonthDropdown}        
              showYearDropdown={showYearDropdown}    
              ref={currentDateRef}    
              disabled={disabled}
              showTimeSelectOnly={showTimeSelectOnly}
              {...(timeFormat && {timeFormat: timeFormat})}
              {...(timeIntervals && {timeIntervals: timeIntervals})}
              {...(timeCaption && {timeCaption: timeCaption})}

          />
        </div>
    </div>
  )
}

export default DatePicker